module.exports = __webpack_public_path__ + "img/1493062554.f3ce0562.jpg";